<button
	[id]="id()"
	(click)="openLink()"
	class="w-full card focus:outline-black"
	data-test-class="tile"
>
	<div
		[class]="
			cn(
				alignment() === 'vertical' && 'flex-col',
				alignment() === 'horizontal' && 'flex-row',
				preventClickEvents() && 'pointer-events-none',
				'flex w-full min-w-0 flex-nowrap items-center gap-2'
			)
		"
	>
		<div
			class="icon-container-md-full icon-fill-accent"
			data-test-id="tile-icon"
		>
			<svg-icon [attr.data-test-id]="icon()" [src]="icon()" />
		</div>
		<span
			[class]="
				cn(
					alignment() === 'vertical' && 'truncate',
					alignment() === 'horizontal' && 'line-clamp-2',
					'w-full min-w-0 text-center text-sm font-semibold md:text-base'
				)
			"
			[title]="title()"
			data-test-id="tile-title"
		>
			{{ title() }}
		</span>
	</div>
</button>
